import React, { useEffect, useRef, useState } from 'react'
import cx from 'classnames'
import s from './Dropdown.module.css'

interface Props {
  children: React.ReactChild
  parentItem: React.ReactNode
  buttonClass: HTMLAttributes<HTMLButtonElement>['className']
}

const Dropdown = ({ children, parentItem, buttonClass }: Props) => {
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef(null) // Ref for the dropdown

  // Function to close the dropdown
  const closeDropdown = () => setOpen(false);

  useEffect(() => {
    // Handler to close dropdown when clicked outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    if (open) {
      // Bind the event listener only when the dropdown is open
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener when the dropdown is closed or the component is unmounted
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]); // Dependency array with 'open' to add/remove event listener based on 'open' state

  let parentComponent = parentItem ? (
    parentItem
  ) : (
    <button
      className={cx(buttonClass, s.dropdownButton)}
      onClick={() => setOpen((prevOpen) => !prevOpen)}
    >
      More
    </button>
  )

  const arrowClass = cx(s.downArrow, {
    [s['downArrow--active']]: open
  })

  return (
    <div className={s.parent} ref={dropdownRef}>
      {parentComponent}
      {open && <div className={s.childrenWrapper}>{children}</div>}
      <span
        onClick={() => setOpen((prevOpen) => !prevOpen)}
        className={arrowClass}
      />
    </div>
  )
}

export default Dropdown
